// @ts-ignore
import {
  AxItem,
  AxItemSearchQuery,
  AxCategoryfilterQuery,
  AxItemSearchResponse,
  itemFields,
  AxItemfilterCategory,
  AxItemfilterVariation,
} from '@/types/AxItem'
import { $axFrontendHelper } from './$axFrontendHelper'
import { axApiPaths } from '@/AxApiPaths'
import Vue from 'vue'
import { $lsCache } from './$lsCache'
import { $appHook } from '@shared/model/$appHook'
import { $AxE2 } from '@/services/$AxE2'
import { $toast } from '../services/$toast'

const perPageDefault = 100
const perPageLsCacheKey = 'AxItemSearchHelper--perPage'
const searchResultLsCacheKeyPrefix = 'AxItemSearchHelper--r-'
export const sortSelect = {
  1: {
    title: 'おすすめ順',
    col: 'item.sortkey',
    sort: false,
  },
  2: {
    title: '価格の安い順',
    col: 'item.skus.sell_price_tax_included',
    sort: false,
  },
  3: {
    title: '価格の高い順',
    col: 'item.skus.sell_price_tax_included',
    sort: true,
  },
}

export type ItemSearchStrategy = 'main' | 'relatedWithItem'
// 3分は結果をキャッシュする (不要なクエリを避けて高速化)
const resultCacheTTL = 180
class AxItemSearchHelper {
  latestResult: AxItemSearchResponse
  // ★確認
  /**
   * TODO: 検索条件をキープしておくオブジェクト。
   */
  searchConditions: any
  /**
   * 検索クエリ
   */
  searchKeywords: string
  /**
   * フィルタ（カテゴリ）情報を保持するオブジェクト
   */
  filterCategory: AxItemfilterCategory
  /**
   * フィルタ（バリデーション）情報を保持するオブジェクト
   */
  filterVariation: AxItemfilterVariation[]
  /**
   * ソート情報を保持するオブジェクト
   */
  sort: [{ field: string; reverse: boolean }]
  /**
   * 検索結果1ページあたりに表示する件数
   */
  perPage: number

  /**
   * 現在のページング番号
   */
  paged: number
  /**
   * 検索対象とするフィールドを絞り込むためのproperty, 初期値は全ItemFieldsだが、
   * Vueから変更できるようにClassProperty化している
   */
  searchTargetItemFields: string[]
  constructor() {
    this.perPage = $lsCache.get(perPageLsCacheKey) || perPageDefault
    this.paged = 1 // TODO: こちらは... ページの状態から取得するべきか？
    this.searchKeywords = ''
    this.filterCategory = null
    this.filterVariation = []
    this.searchConditions = {}
    this.latestResult = {
      facet: {},
      hit: null,
      items: [],
    }
    this.searchTargetItemFields = itemFields // default値
  }
  // ★確認
  async findWith(strategy: ItemSearchStrategy, args) {}
  async find() {
    return this.findWithCurrentQuery()
  }

  async clearFilter() {
    this.filterCategory = null
    this.filterVariation = []
  }

  async findWithCurrentQuery() {
    try {
      const searchParam = this._buildSearchParam()
      const res = await $axFrontendHelper.request<AxItemSearchResponse>({
        path: axApiPaths.items.search,
        data: searchParam,
      })
      Vue.set(this, 'latestResult', res.result)
      // 値をhtmlへ渡す
      if ($appHook.hasHook($AxE2.hooks.itemList)) {
        $appHook.callHooks($AxE2.hooks.itemList, res.result.items, this)
      }

      return this.latestResult
      // ★確認
      // // キャッシュする with クエリの状態
      // const cacheKey = searchResultLsCacheKeyPrefix + JSON.stringify(searchParam)
      // const result = await $lsCache.getWithFetchFunc(cacheKey, async () => {
      //   const res = await $axFrontendHelper.request<AxItemSearchResponse>({
      //     path: axApiPaths.items.search,
      //     data: searchParam
      //   })
      //   return res.result
      // })
      // // keep responsive
      // this.latestResult = Object.assign({}, this.latestResult, result)
      // return this.latestResult
    } catch (e) {
      $toast.error('商品の検索に失敗しました。')
    }
  }
  /**
   * AxItemSearchQuery 用に検索条件構造を生成
   * TODO: generate with this.searchConditions (with Vue UI interactions)
   */
  _buildSearchParam(): AxItemSearchQuery {
    const limit = this.perPage
    const offset = this.perPage * ((this.paged || 1) - 1)
    const res: AxItemSearchQuery = {
      query: {
        limit,
        offset,
      },
      request: {
        fields: itemFields, // all field
      },
    }
    // 検索キーワードの設定
    if (this.searchKeywords) {
      res.query.keyword = {
        operator: 'and',
        queries: [
          {
            fields: ['item.name', 'item.name_read'],
            keyword: this.searchKeywords,
          },
        ],
      }
    }
    res.query.filters = [{ operator: 'and', filters: [{ field: '', value: '' }] }]
    if (this.filterCategory || this.filterVariation.length != 0) {
      if (this.filterCategory) {
        // "compare,or_null は省略
        var searchKey = ''
        var searchVlue = ''
        if (this.filterCategory.code != '') {
          searchKey = '.code'
          searchVlue = this.filterCategory.code
        } else {
          searchKey = '.id'
          searchVlue = this.filterCategory.id
        }
        res.query.filters.push({
          operator: 'and',
          filters: [
            {
              field: 'item.categories.' + this.filterCategory.treeCode + searchKey,
              value: searchVlue,
            },
          ],
        })
      }
      // バリエーション
      if (this.filterVariation.length != 0) {
        var filters: AxCategoryfilterQuery = [{ field: '', value: '' }]

        for (var i = 0; this.filterVariation.length > i; i++) {
          // "compare,or_null は省略
          var searchKey = ''
          var searchVlue = ''
          if (this.filterVariation[i].selectCode != '') {
            searchKey = '.code'
            searchVlue = this.filterVariation[i].selectCode
          } else {
            searchKey = '.name'
            searchVlue = this.filterVariation[i].selectnName
          }
          filters.push({
            field: 'item.skus.variation.' + this.filterVariation[i].vCode + searchKey,
            value: searchVlue,
          })
        }
        filters.splice(0, 1)
        res.query.filters.push({
          operator: 'and',
          filters: filters,
        })
      }
      res.query.filters.splice(0, 1)
    }
    // ソート
    res.query.sorts = this.sort
    return res
  }

  /**
   * Find item by id
   */
  async findById(itemId): Promise<AxItem> {
    const res = await $axFrontendHelper.request<{ items: AxItem[] }>({
      path: axApiPaths.items.get,
      data: {
        query: {
          items: [{ id: itemId }],
        },
        request: {
          fields: itemFields, // all field
        },
      },
    })
    return res.result.items[0]
  }

  /**
   * Find item by Code
   */
  async findByCode(itemCode): Promise<AxItem> {
    const res = await $axFrontendHelper.request<{ items: AxItem[] }>({
      path: axApiPaths.items.get,
      data: {
        query: {
          items: [{ code: itemCode }],
        },
        request: {
          fields: itemFields, // all field
        },
      },
    })
    if (!res.result.items) {
      return null
    }
    return res.result.items[0]
  }

  selectedSort(serectSort) {
    this.sort = [{ field: sortSelect[serectSort].col, reverse: sortSelect[serectSort].sort }]
  }
}

export const $axItemSearchHelper = Vue.observable(new AxItemSearchHelper())
